import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getMatches } from './firebaseUtils';

function PremiumContent() {
  const navigate = useNavigate();
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchMatches = async () => {
      const data = await getMatches();
      setMatches(data);
      setLoading(false);
    };
    fetchMatches();
  }, []);

  const isNew = (dateAdded) => {
    if (!dateAdded) return false;
    const added = dateAdded.toDate ? dateAdded.toDate() : new Date(dateAdded);
    const daysDiff = (new Date() - added) / (1000 * 60 * 60 * 24);
    return daysDiff <= 14;
  };

  const getYoutubeThumbnail = (url) => {
    if (!url || url === 'TBD') return null;
    const match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([^&\n?#]+)/);
    return match ? `https://img.youtube.com/vi/${match[1]}/hqdefault.jpg` : null;
  };

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#111',
      color: '#fff',
      paddingTop: '80px',
      paddingBottom: '60px',
    }}>
      <div style={{
        maxWidth: '700px',
        margin: '0 auto',
        padding: '0 16px',
      }}>

        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <h1 style={{
            fontFamily: 'Bangers, sans-serif',
            fontSize: 'clamp(2rem, 7vw, 3rem)',
            letterSpacing: '2px',
            color: '#FFD700',
            marginBottom: '8px',
          }}>
            🏆 Founding Members Exclusive
          </h1>
          <p style={{ color: '#aaa', fontSize: '1rem' }}>
            Full match footage — content you won't find anywhere else
          </p>
        </div>

        {loading ? (
          <p style={{ textAlign: 'center', color: '#888' }}>Loading matches...</p>
        ) : matches.length === 0 ? (
          <div style={{
            backgroundColor: '#1a1a1a',
            borderRadius: '12px',
            padding: '40px',
            textAlign: 'center',
          }}>
            <p style={{ fontSize: '3rem', marginBottom: '16px' }}>🎬</p>
            <p style={{ color: '#aaa', fontSize: '1.1rem' }}>
              Exclusive match footage dropping soon. Stay tuned!
            </p>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            {matches.map((match) => {
              const thumbnail = getYoutubeThumbnail(match.youtubeUrl);
              const newMatch = isNew(match.dateAdded);
              const hasVideo = match.youtubeUrl && match.youtubeUrl !== 'TBD';

              return (
                <div
                  key={match.id}
                  style={{
                    backgroundColor: '#1a1a1a',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    borderLeft: '4px solid #FFD700',
                    cursor: hasVideo ? 'pointer' : 'default',
                  }}
                  onClick={() => hasVideo && window.open(match.youtubeUrl, '_blank')}
                >
                  {thumbnail ? (
                    <div style={{ position: 'relative' }}>
                      <img
                        src={thumbnail}
                        alt={match.title}
                        style={{
                          width: '100%',
                          height: '200px',
                          objectFit: 'cover',
                          display: 'block',
                        }}
                      />
                      <div style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        backgroundColor: 'rgba(0,0,0,0.7)',
                        borderRadius: '50%',
                        width: '60px',
                        height: '60px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '1.5rem',
                      }}>
                        ▶
                      </div>
                      {newMatch && (
                        <div style={{
                          position: 'absolute',
                          top: '12px',
                          right: '12px',
                          backgroundColor: '#FFD700',
                          color: '#000',
                          borderRadius: '6px',
                          padding: '4px 10px',
                          fontSize: '0.8rem',
                          fontFamily: 'Bangers, sans-serif',
                          letterSpacing: '1px',
                        }}>
                          NEW
                        </div>
                      )}
                    </div>
                  ) : (
                    <div style={{
                      backgroundColor: '#222',
                      height: '120px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      position: 'relative',
                    }}>
                      <span style={{ fontSize: '2.5rem' }}>🎬</span>
                      {newMatch && (
                        <div style={{
                          position: 'absolute',
                          top: '12px',
                          right: '12px',
                          backgroundColor: '#FFD700',
                          color: '#000',
                          borderRadius: '6px',
                          padding: '4px 10px',
                          fontSize: '0.8rem',
                          fontFamily: 'Bangers, sans-serif',
                          letterSpacing: '1px',
                        }}>
                          NEW
                        </div>
                      )}
                    </div>
                  )}

                  <div style={{ padding: '16px' }}>
                    {match.dayNumber && (
                      <span style={{
                        color: '#FFD700',
                        fontFamily: 'Bangers, sans-serif',
                        fontSize: '0.95rem',
                        letterSpacing: '1px',
                        marginBottom: '4px',
                        display: 'block',
                      }}>
                        Day {match.dayNumber}
                      </span>
                    )}
                    <h3 style={{
                      color: '#fff',
                      fontFamily: 'Bangers, sans-serif',
                      fontSize: '1.3rem',
                      letterSpacing: '1px',
                      marginBottom: '4px',
                    }}>
                      {match.title}
                    </h3>
                    <p style={{ color: '#888', fontSize: '0.85rem', marginBottom: '8px' }}>
                      {match.tournament}
                    </p>
                    <p style={{ color: '#ccc', fontSize: '0.9rem', marginBottom: '12px' }}>
                      {match.description}
                    </p>
                    {hasVideo ? (
                      <div style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '6px',
                        color: '#FFD700',
                        fontSize: '0.9rem',
                        fontWeight: 'bold',
                      }}>
                        ▶ Watch Full Match
                      </div>
                    ) : (
                      <div style={{
                        color: '#666',
                        fontSize: '0.85rem',
                        fontStyle: 'italic',
                      }}>
                        🎬 Coming soon
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}

        <div style={{
          textAlign: 'center',
          marginTop: '40px',
          padding: '24px',
          backgroundColor: '#1a1a1a',
          borderRadius: '12px',
        }}>
          <p style={{ color: '#aaa', fontSize: '0.9rem', marginBottom: '12px' }}>
            New matches drop regularly. Follow @BenjaminKinney365 on Instagram for announcements.
          </p>
          <button
            onClick={() => navigate('/fargo')}
            style={{
              backgroundColor: 'transparent',
              color: '#FFD700',
              border: '1px solid #FFD700',
              borderRadius: '8px',
              padding: '10px 20px',
              fontSize: '0.95rem',
              fontFamily: 'Bangers, sans-serif',
              letterSpacing: '1px',
              cursor: 'pointer',
            }}
          >
            🏆 Back to Fargo Campaign
          </button>
        </div>

      </div>
    </div>
  );
}

export default PremiumContent;